import React, { ReactNode } from 'react';

import { PopupContainer } from 'src/app/components/Popup/PopupContainer';
import { PopupError } from 'src/app/components/Popup/PopupError';
import { POPUPERROR_TYPE } from 'src/app/constants/popup';

interface MyOwnProps {
  onError?: (error: Error, componentStack: string) => void;
}

type MyProps = MyOwnProps;

interface ErrorInfo {
  componentStack: string;
}

interface MyState {
  error: Error | null;
  info: ErrorInfo | null;
}

class MyErrorBoundary extends React.Component<MyProps, MyState> {
  constructor(props: MyProps) {
    super(props);

    this.state = {
      error: null,
      info: null
    };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    this.setState({ error, info });
  }

  render(): JSX.Element | ReactNode {
    const { children } = this.props;
    const { error } = this.state;

    if (error !== null) {
      return (
        <PopupContainer>
          <PopupError
            error={POPUPERROR_TYPE.GENERAL}
          />
        </PopupContainer>
      );
    }

    return children;
  }
}

export const ErrorBoundary = MyErrorBoundary as React.ComponentClass<MyOwnProps>;
